import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  Home, Book, BarChart2, CreditCard, 
  BookOpen, Timer, Import, User, LogOut,Code, Paintbrush
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuth } from '@/hooks/useAuth';
import { motion } from 'framer-motion';

export function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, isAdmin, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/auth');
  };

  const navigation = [
    { name: 'Home', href: '/home', icon: Home },
    { name: 'MS Paint Idea', href: '/mspaint', icon: Paintbrush },
    ...(isAdmin ? [{ name: 'Content', href: '/content', icon: Book }] : []),
    ...(isAdmin ? [{ name: 'Practice', href: '/codespace', icon: Code }] : []),
    ...(isAdmin ? [{ name: 'Dashboard', href: '/dashboard', icon: BarChart2 }] : []),
    ...(isAdmin ? [{ name: 'Flashcards', href: '/flashcards', icon: BookOpen }] : []),
    ...(isAdmin ? [{ name: 'Speedrun', href: '/speedrun', icon: Timer }] : []),
    ...(isAdmin ? [{ name: 'Blog Import', href: '/blog-import', icon: Import }] : []),
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="bg-white shadow-lg sticky top-0 z-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <motion.div
                whileHover={{ scale: 1.05 }}
                className="text-xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 text-transparent bg-clip-text"
              >
                EduCMS
              </motion.div>
            </Link>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
              {navigation.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.href;
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={cn(
                      'inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors duration-200',
                      isActive
                        ? 'border-blue-500 text-gray-900'
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                    )}
                  >
                    <Icon className="w-4 h-4 mr-2" />
                    {item.name}
                  </Link>
                );
              })}
            </div>
          </div>
          <div className="flex items-center space-x-4">
            {isAuthenticated ? (
              <>
                <span className="text-sm text-gray-500">
                  {isAdmin ? 'Admin' : 'User'}
                </span>
                <button
                  onClick={handleLogout}
                  className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  <LogOut className="w-4 h-4 mr-2" />
                  Logout
                </button>
              </>
            ) : (
              <Link
                to="/happy"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                <User className="w-4 h-4 mr-2" />
                Have a Good Day
              </Link>
            )}
          </div>
        </div>
      </div>
    </motion.nav>
  );
}